module.exports = __webpack_public_path__ + "img/REG_ALIM_VEGETARIEN_LISTE_NOM.a902abc6.svg";